/**
 * ver 0.1
 * author jspark
 * created 18-12-10
 */
import React from 'react';
import { itemImage, numberFormat } from 'common/util/util';
class ReportLayer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            claimNum: 0,
            caveat: 0,
            msg: ""
        }
    }
    itCategory(arr) {
        let cate = [];
        arr.forEach((v) => {
            if (v.sid === 1) cate.push(v.cate_name);
        });
        return <span className="cate">상품분류 : {cate[0]} &gt; {cate[1]}</span>;
    }
    sendReport() {
        if (this.state.claimNum === 0) {
            this.setState({ caveat: 1 });
        }
        else if (this.state.claimNum === 11 && this.state.msg === "") {
            this.setState({ caveat: 2 });
        } else {
            this.props.send(this.state.claimNum, this.state.msg);
        }
    }
    render() {
        const { data, shop, type } = this.props;
        const { caveat } = this.state;
        const it = data ? data.item : false;
        const price = it.minishop && it.minishop.price_b2c ? it.minishop.price_b2c : 0;
        const priceLow = it.price_low ? it.price_low : 0;
        const zeroTxt = shop ? '일시 품절' : '가격비교 예정'

        return (
            <table id="lyrPop">
                <tbody><tr><td>
                    <div className="PopMain caveatPop">
                        <strong className="popName">신고하기</strong>
                        <table className="caveatTable">
                            <tbody>
                                <tr>
                                    <th>신고대상</th>
                                    <td>
                                        {it ?
                                            <React.Fragment>
                                                <div className="rpTarget">
                                                    {itemImage({ imgUrl: it.thumbnail.imgPath, noImgUrl: it.thumbnail.errorPath }, it.item_name, 200, 0, "rpImg")}
                                                    <div className="rpInfo">
                                                        {shop ?
                                                            <React.Fragment>
                                                                <p className="clrpont1">판매처 : {shop.mall_name}</p>
                                                                <b>{data.item.full_item_name}</b>
                                                                {price < 1 ?
                                                                    <b className="clrpont2 mkPrice">{zeroTxt}</b>
                                                                    :
                                                                    <b className="clrpont2 won mkPrice">{numberFormat(price)}</b>
                                                                }
                                                            </React.Fragment>
                                                            :
                                                            <React.Fragment>
                                                                <b>{data.item.full_item_name}</b>
                                                                {priceLow < 1 ?
                                                                    <b className="clrpont2 mkPrice">{zeroTxt}</b>
                                                                    :
                                                                    <b className="lowestP mkPrice">{numberFormat(priceLow)}</b>
                                                                }
                                                            </React.Fragment>
                                                        }
                                                    </div>
                                                </div>
                                                <p className="rpSpec">
                                                    <span>제조사 : {it.maker_name}</span>
                                                    {/* <span>유통사 : STCOM</span><span>브랜드 : STRIX</span> */}
                                                    {this.itCategory(data.nav)}
                                                </p>
                                            </React.Fragment>
                                            :
                                            <div className="rpTarget">
                                                <div className="rpInfo">
                                                    <p className="clrpont1">판매처 : {shop.mall_name}</p>
                                                </div>
                                            </div>
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <th>신고사유</th>
                                    <td>
                                        <div className="rpLines">
                                            {type.map((v) => {
                                                let cls = caveat === 1 ? "iradio caveat" : "iradio";
                                                return (
                                                    <div className="rLine" key={"type" + v.idx_top_notify}>
                                                        <span className={cls}>
                                                            <input type="radio" id={"ct" + v.idx_top_notify} name="ct1" defaultValue={v.idx_top_notify} />
                                                            <label htmlFor={"ct" + v.idx_top_notify} onClick={() => this.setState({ claimNum: v.idx_top_notify, caveat: 0 })}>{v.ment_notify}</label>
                                                        </span>
                                                    </div>
                                                )
                                            })}
                                            <div className="rLine">
                                                <textarea className={caveat === 2 ? "etcTxt caveat" : "etcTxt"} placeholder="항목에 없는 자세한 내용을 적어주세요." defaultValue={""} onChange={(e) => this.setState({ msg: e.target.value, caveat: 0 })} />
                                                {caveat === 1 && <font className="clrpont2">하나 이상의 신고 사유를 선택해 주세요.</font>}
                                                {caveat === 2 && <font className="clrpont2">신고 내용을 작성해 주세요.</font>}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>참고사항</th>
                                    <td>
                                        <p className="rNoti">
                                            · 다량의 허위신고 접수 시 신고가 자동으로 차단될 수 있습니다.<br />
                                            · 신고 처리결과는 별도로 답변 드리지 않습니다.
                                        </p>
                                    </td>
                                </tr>
                            </tbody></table>
                        <div className="popDefBtns">
                            <button className="icon-X_close" onClick={() => this.props.onClose()} />
                            <button className="styWBg" onClick={() => this.props.onClose()}>취소</button>
                            <button className="styPBg" onClick={() => this.sendReport()}>신고하기</button>
                        </div>
                    </div>
                </td></tr></tbody>
            </table>
        )
    }
}
export default ReportLayer



// WEBPACK FOOTER //
// ./src/common/container/layer/reportLayer.js